import React, { FC, useRef, useCallback, useState, ReactElement } from 'react';

import { functionNoop } from 'src/utils/function/noop';
import { JourneyMenu } from 'src/common/JourneyMenu';

import { EditorConfirmPanel } from '../confirm-panel';
import { DeleteRegularIcon } from 'src/monet/icons';

interface EditorSectionOptionsProps {
  renderOrigin: (onClick: any) => ReactElement;
  onMenuOpen?: () => void;
  onMenuClose?: () => void;
  onDeleteConfirmClicked: () => void;
}

const menuItemClasses = 'text-bedrock-p text-bedrock-black flex items-center space-x-sm';

export const EditorSectionOptions: FC<EditorSectionOptionsProps> = ({
  renderOrigin,
  onMenuOpen,
  onMenuClose = functionNoop,
  onDeleteConfirmClicked,
}) => {
  const settingsMenuOpenRef = useRef(functionNoop);
  const settingsMenuCloseRef = useRef(functionNoop);

  const deletePanelOpenRef = useRef(functionNoop);
  const deletePanelCloseRef = useRef(functionNoop);

  const [deleteOpen, setDeleteOpen] = useState(false);

  const onMenuClicked = useCallback(() => {
    settingsMenuOpenRef.current();
  }, [settingsMenuOpenRef]);

  const onSectionDeleteClicked = useCallback(() => {
    setDeleteOpen(true);
  }, []);

  const onBack = () => {
    setDeleteOpen(false);
    deletePanelCloseRef.current();
    setTimeout(onMenuClicked, 50);
  };

  if (deleteOpen) {
    return (
      <EditorConfirmPanel
        offset={[0, 0]}
        placement='right-start'
        renderOrigin={() => renderOrigin(onMenuClicked)}
        copy='Deleting this Section will remove the content from this Journey. The content will remain in your Content Library.'
        confirmCopy='Yes, delete'
        denyCopy='No, keep'
        openRef={deletePanelOpenRef}
        closeRef={deletePanelCloseRef}
        onBack={onBack}
        onOpen={onMenuOpen}
        onConfirm={onDeleteConfirmClicked}
        onDeny={() => {
          setDeleteOpen(false);
          onMenuClose();
        }}
        onClose={() => {
          setDeleteOpen(false);
          onMenuClose();
        }}
      />
    );
  }

  return (
    <JourneyMenu
      placement='right-start'
      popperClassName='!fixed'
      openRef={settingsMenuOpenRef}
      closeRef={settingsMenuCloseRef}
      onOpen={onMenuOpen}
      onClose={onMenuClose}
      renderOrigin={() => renderOrigin(onMenuClicked)}
    >
      <JourneyMenu.Item className={menuItemClasses} onClick={onSectionDeleteClicked}>
        <DeleteRegularIcon />
        <span>Delete</span>
      </JourneyMenu.Item>
    </JourneyMenu>
  );
};
